import React from "react";
import styled, { css } from "styled-components";
import PropTypes from "prop-types";

import { Colors, Spacing } from "@paclife/plds.tokens";

import { Icon } from "@paclife/plds.icon";
import Typography from "common/Typography/Typography";

const Wrapper = styled.div`
    min-height: 40px;
    background-color: ${({ type }) =>
        type === "error" ? Colors.red100 : Colors.green100};
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 12px; // no token for 12px
    margin: ${Spacing[16]} 0;
    ${({ align }) =>
        align === "left" &&
        css`
            justify-content: flex-start;
        `}

    & > svg.error-icon {
        min-width: 16px;
    }
`;

const Message = styled(Typography)`
    font-style: italic;
    margin-left: ${Spacing[8]};
`;

const ErrorMessage = ({ className, message, align, type }) => {
    return (
        <Wrapper className={className} align={align} type={type}>
            <Icon
                className="error-icon"
                name={type === "error" ? "alert" : "checkmarkOutline"}
                width={16}
                color={type === "error" ? Colors.red500 : Colors.green500}
            />
            <Message variant="microcopy">{message}</Message>
        </Wrapper>
    );
};

export default ErrorMessage;

ErrorMessage.propTypes = {
    className: PropTypes.string,
    message: PropTypes.string.isRequired,
    type: PropTypes.oneOf(["error", "success"]).isRequired,
    align: PropTypes.oneOf(["left", "center", "right"])
};

ErrorMessage.defaultProps = {
    className: "",
    align: "left"
};
